import React, { createContext, useState } from "react";

export enum IloadingType {
    loading = "loading",
    saving = "saving"
}

export interface IPlannerSettingsContext {
    selectedUsers: any[],
    selectedGroups: any[],
    setSelectedUsers: (data: any[]) => void,
    setSelectedGroups: (data: any[]) => void,
    permissions:permissions,
    setPermissions:(data:permissions) => void,
    loading:boolean,
    setLoading:(loading:boolean) => void
    loadingType:IloadingType,
    setLoadingType: (loadingType:IloadingType) => void
}

const plannerDefaults:IPlannerSettingsContext = {
    selectedUsers: [],
    selectedGroups: [],
    setSelectedUsers: (data: any[]) => {},
    setSelectedGroups: (data: any[]) => {},
    permissions:{
        canAddCalendar:false,
        canDeleteCalendar:false,
        canManageCalendar:false,
        canViewCalendarSettings:false
    },
    setPermissions: (data:any) => {},
    loading:false,
    setLoading: () => {}, 
    loadingType:null,
    setLoadingType:() => {}
}

export interface permissions {
    canAddCalendar:boolean,
    canDeleteCalendar:boolean,
    canManageCalendar:boolean,
    canViewCalendarSettings:boolean
}

export const PlannerSettingsContext = createContext(plannerDefaults);

const Get = ({ children }:{children:React.ReactNode}) => {

    const [selectedUsers, setSelectedUsers ] = useState<any[]>([]);
    const [selectedGroups, setSelectedGroups ] = useState<any[]>([]);
    const [permissions, setPermissions] = useState<permissions>(plannerDefaults.permissions)
    const [loading, setLoading] = useState<boolean>(false)
    const [loadingType, setloadingType] = useState<IloadingType>(null)

    const context:IPlannerSettingsContext = {
        selectedUsers: selectedUsers,
        selectedGroups: selectedGroups,
        setSelectedUsers: setSelectedUsers,
        setSelectedGroups :setSelectedGroups,
        permissions: permissions,
        setPermissions: setPermissions,
        loading:loading, 
        setLoading:setLoading, 
        loadingType: loadingType,
        setLoadingType: setloadingType
    }

    return (
        <PlannerSettingsContext.Provider value={context}>
            {children}
        </PlannerSettingsContext.Provider>
    )
}

export default Get;